import { c as _c } from "react/compiler-runtime";
export function MastercardIcon(t0) {
  const $ = _c(9);
  const {
    decorative
  } = t0;
  const t1 = decorative ? undefined : "img";
  const t2 = decorative ? undefined : "Mastercard";
  const t3 = decorative || undefined;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z" />;
    t5 = <path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32" />;
    t6 = <circle fill="#EB001B" cx="15" cy="12" r="7" />;
    t7 = <circle fill="#F79E1B" cx="23" cy="12" r="7" />;
    t8 = <path fill="#FF5F00" d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z" />;
    $[0] = t4;
    $[1] = t5;
    $[2] = t6;
    $[3] = t7;
    $[4] = t8;
  } else {
    t4 = $[0];
    t5 = $[1];
    t6 = $[2];
    t7 = $[3];
    t8 = $[4];
  }
  let t9;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t9 = <svg className="icon icon--full-color" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="38" height="24" role={t1} aria-label={t2} aria-hidden={t3}>{t4}{t5}{t6}{t7}{t8}</svg>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  return t9;
}